/** A US bank routing (ABA) number: nine digits that pass the bank's own checksum, which catches nearly every typo. */
export function validRouting(n: string): boolean {
  if (!/^\d{9}$/.test(n)) return false;
  const d = [...n].map(Number);
  return (3 * (d[0]! + d[3]! + d[6]!) + 7 * (d[1]! + d[4]! + d[7]!) + (d[2]! + d[5]! + d[8]!)) % 10 === 0;
}

export const validAccountNo = (n: string) => /^\d{4,17}$/.test(n);

/**
 * The line along the bottom of a check, in the order banks read it: check number, then routing, then account.
 * The symbols are the MICR ones: ⑈ on-us, ⑆ transit. Printed in a MICR E-13B font they are machine readable.
 */
export function micrLine(checkNo: number | string, routing: string, account: string): string {
  return `⑈${String(checkNo).padStart(6, '0')}⑈ ⑆${routing}⑆ ${account}⑈`;
}
